<template>
  <PopoverMenu
    v-if="hasUnsavedChanges"
    ref="popoverMenu"
    position="bottom-right"
    :has-arrow="false"
  >
    <template #toggle-button>
      <ButtonItem
        theme="link"
        :text="t('dataGrid.views.save')"
        :data-qa="dataGridViewsDataQa.saveBtn"
      />
    </template>
    <template #popover-content>
      <div class="save-view-menu">
        <TooltipButton :text="saveEditsDisabledTooltip">
          <ButtonItem
            class="save-view-item"
            theme="ghost"
            :text="t('dataGrid.views.saveEdits')"
            :is-disabled="isSaveEditsDisabled"
            :data-qa="dataGridViewsDataQa.saveEditsBtn"
            @click="handleSaveEdits"
          />
        </TooltipButton>
        <ButtonItem
          class="save-view-item"
          theme="ghost"
          :text="t('dataGrid.views.saveAsNewView')"
          :data-qa="dataGridViewsDataQa.saveAsNewBtn"
          @click="handleSaveAsNew"
        />
      </div>
    </template>
  </PopoverMenu>
</template>

<script setup lang="ts">
import { ButtonItem, PopoverMenu } from '@lw-design-system/ui';
import { storeToRefs } from 'pinia';
import { useViewsStore } from '@/stores/views-store';
import { dataGridViewsDataQa } from '~/constants/commons/data-qa';
import TooltipButton from '~/components/common/item/TooltipButton.vue';

const { t } = useI18n();

const emit = defineEmits<{
  (e: 'save-as-new'): void;
  (e: 'save-edits'): void;
}>();

const viewsStore = useViewsStore();
const { hasUnsavedChanges } = storeToRefs(viewsStore);

const popoverMenu = ref<InstanceType<typeof PopoverMenu> | undefined>(undefined);

const isSaveEditsDisabled = computed(() => viewsStore.activeView?.isDefault ?? true);
const saveEditsDisabledTooltip = computed(() =>
  isSaveEditsDisabled.value ? t('dataGrid.views.defaultEditDisabledTooltip') : undefined
);

const handleSaveAsNew = () => {
  popoverMenu.value?.handleClick();
  emit('save-as-new');
};

const handleSaveEdits = () => {
  popoverMenu.value?.handleClick();
  emit('save-edits');
};
</script>

<style scoped>
.save-view-menu {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 12rem;
}

.save-view-item {
  width: 100%;
}
</style>
